.root {
    position: relative;
    z-index: 2;

    & video,
    & img,
    & picture {
        display: block;
        overflow: hidden;
        width: 100vw;
    }
}
